'use client';
import { useEffect, useMemo, useState } from 'react';
import { useStore } from '@/app/providers/store';
import { computeClawPassExpireState } from '../_utils/claw-pass-expire';

const TICK_INTERVAL_MS = 60 * 1000;

/**
 * Claw 权益包过期状态 hook，每分钟刷新一次时间戳触发重渲染。
 * banner（顶部）与 popover（侧栏头像悬浮卡）共用，避免两处维护一致的展示规则。
 */
export const useClawPassExpire = () => {
  const clawPass = useStore((state) => state.clawPass);
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!clawPass?.has_benefit || !clawPass?.valid_to) return;
    const id = setInterval(() => setNowMs(Date.now()), TICK_INTERVAL_MS);
    return () => clearInterval(id);
  }, [clawPass?.has_benefit, clawPass?.valid_to]);

  return useMemo(() => computeClawPassExpireState(clawPass, nowMs), [clawPass, nowMs]);
};
